export default "__VITE_ASSET__CVMLyIvY__"